import { normalizeUrl, urlExtractFromLink } from '@seb-platform/shared/utils/url';
import { Locale } from '~/types/locales';
import type { StoryblokMultilink } from '~/types/storyblok-generated';

const localeToContactUrlMap: Record<Locale, string> = {
  [Locale.DE_AT]: '/kontakt',
  [Locale.DE_CH]: '/kontakt',
  [Locale.DE_DE]: '/kontakt',
  [Locale.EN_COM]: '/contact',
  [Locale.EN_UK]: '/contact',
  [Locale.EN_US]: '/contact',
  [Locale.ES_ES]: '/contacto',
  [Locale.FR_BE]: '/contact',
  [Locale.FR_CH]: '/contact',
  [Locale.FR_FR]: '/contact',
  [Locale.JA_JP]: '/contact',
  [Locale.NL_BE]: '/contact',
  [Locale.NL_NL]: '/contact',
  [Locale.PL_PL]: '/kontakt',
  [Locale.ZH_CN]: '/contact',
};

export function urlIsContact(link: StoryblokMultilink, locale: Locale): boolean {
  const url = urlExtractFromLink(link);
  return url ? isContactUrl(url, locale) : false;
}
export function isContactUrl(url: string, locale: Locale): boolean {
  const contactUrl = localeToContactUrlMap[locale];
  const normalized = normalizeUrl(url);
  return normalized.startsWith(`/${locale}${contactUrl}`);
}
